import React from 'react';

function BonusIcon({ width = 24, height = 24, className = "",color}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 15.654 14.281">
            <path
                id="Vector_-_2025-02-10T181155.433"
                data-name="Vector - 2025-02-10T181155.433"
                d="M5.735,0A2.14,2.14,0,0,0,3.679,2.9H1.423A1.423,1.423,0,0,0,0,4.319V5.742a.712.712,0,0,0,.712.712h6.4V4.319H8.539V6.454h6.4a.712.712,0,0,0,.712-.712V4.319A1.423,1.423,0,0,0,14.231,2.9H11.976A2.134,2.134,0,0,0,8.233.932l-.406.541L7.422.918A2.058,2.058,0,0,0,5.735,0ZM5.692,1.473a.712.712,0,1,1-.5.208A.714.714,0,0,1,5.692,1.473Zm4.269,0a.712.712,0,1,1-.5.208A.714.714,0,0,1,9.962,1.473ZM.712,7.165v5.692a1.423,1.423,0,0,0,1.423,1.423H13.52a1.423,1.423,0,0,0,1.423-1.423V7.165h-6.4v5.692H7.116V7.165Z"
                fill="currentcolor"
            />
        </svg>
    );
}

export default BonusIcon;
